<template>
  <div
    class="web-003"
  >
    <template v-if="requestTreeList">
      <navigation
        ref="nav"
        :website-msg="websiteMsg"
      />
      <div
        id="web-003-home-content"
        class="web-content"
      >
        <el-scrollbar
          class="web-003-scrollbar"
          style="height: 100%; overflow-x: hidden"
        >
          <router-view />
          <flooter :website-msg="websiteMsg" />
        </el-scrollbar>
      </div>
      <div
        v-show="showBackTop"
        class="backTopDiv"
        @click="backTop"
      >
        <i class="el-icon-caret-top" />
      </div>
    </template>
  </div>
</template>

<script>
/*
   1.顶部导航fixed，宽度是整个网页宽度
   2.首页轮播图，宽度是整个网页宽度，高度是500px
   3.内容区宽度是1210px
* */
import navigation from './components/navigation';
import flooter from './components/flooter';
import { removeWatermark, setWaterMark } from '../../../../lib/watermark';
import { $debounce } from '../../../../lib/functional';
import api from '../proxy';

export default {
    name: 'Index',
    components: { navigation, flooter },
    data () {
        return {
            websiteMsg: {},
            showBackTop: false,
            onScroll: $debounce(this.onContentScroll, 100),
            requestTreeList: false,
        };
    },
    computed: {
        flatTreeList () {
            return this.$store.getters['system/getFlatTreeList'];
        },
    },
    watch: {
        flatTreeList (val) {
            if (val.length) {
                this.initScrollEvt();
            }
        },
        $route (val) {
            if (val.path === '/webModulePage/home') {
                this.$refs.nav && (this.$refs.nav.activeIndex = '0');
            }
        },
    },
    created () {
        const yxpPageManage = document.querySelector('#yxpPageManage');
        yxpPageManage && (yxpPageManage.style.overflow = 'hidden');
        try {
            this.websiteMsg = JSON.parse(sessionStorage.getItem('websiteMsg')) || {};
            this.$store.commit('system/mu_webSiteOrgId', this.websiteMsg.orgId);
            this.$store.commit('system/mu_webSiteOrgType', this.websiteMsg.orgType);
            if (+this.websiteMsg.isLogin !== 0 && !this.$store.getters['global/isLogin']) {
                sessionStorage.setItem('webModulePagePath', this.$route.path);
                this.$router.replace({
                    path: '/transfer',
                    query: { siteId: this.websiteMsg.id, backPath: this.$route.path },
                });
                return;
            }
            if (this.websiteMsg.isPreview || this.$route.query.preview === '1') {
                setTimeout(() => {
                    setWaterMark(this.websiteMsg.name, '预览');
                }, 200);
            }
        } catch (e) {
        }
        const route = this.$router.history.current;
        if (route.query.userToken) {
            this.$router.replace({
                path: '/transfer',
                query: Object.assign({}, route.query, { backPath: route.path }),
            });
            return;
        }
        if (route.path === '/webModulePage' || route.path === '/webModulePage/home') {
            const query = { siteId: this.websiteMsg.id };
            if (this.websiteMsg.isPreview || this.$route.query.preview === '1') {
                query.preview = '1';
            }
            this.$router.replace({
                path: '/webModulePage/home',
                query,
            });
        }
        api.getTreeList({ siteId: this.websiteMsg.id, isShowDisable: 0 }).then(res => {
            if (res.errcode === 0) {
                const catalogList = res.data.value.catalogList;
                this.$store.commit('system/mu_flatTreeList', this.getFlatTreeList(catalogList));
                this.requestTreeList = true;
            } else {
                this.$message.error(res.errmsg);
            }
        });
    },
    mounted () {
        this.initScrollEvt();
        document.removeEventListener('visibilitychange', this.onVisibilitychange);
        document.addEventListener('visibilitychange', this.onVisibilitychange);
        this.$store.commit('system/mu_docmentHidden', false);
    },
    beforeDestroy () {
        document.removeEventListener('visibilitychange', this.onVisibilitychange);
        this.webContent && this.webContent.removeEventListener('scroll', this.onScroll);
        removeWatermark();
    },
    methods: {
        onVisibilitychange (e) {
            if (!document.hidden) {
                const yxpLoginInfo = window.yxpapi.stroage.persistent.get('yxpLoginInfo');
                if (yxpLoginInfo) {
                    this.$store.commit('global/setLoginProp', yxpLoginInfo);
                }
            }
            this.$store.commit('system/mu_docmentHidden', document.hidden);
        },
        initScrollEvt () {
            this.$nextTick(() => {
                if (!this.webContent) {
                    this.webContent = document.querySelector('#web-003-home-content .el-scrollbar__wrap');
                    if (this.webContent) {
                        this.webContent.addEventListener('scroll', this.onScroll);
                        this.onContentScroll();
                    }
                }
            });
        },
        backTop () {
            this.webContent && (this.webContent.scrollTop = 0);
        },
        onContentScroll () {
            if (this.webContent && this.webContent.scrollTop > 400) {
                this.showBackTop = true;
            } else {
                this.showBackTop = false;
            }
        },
        getFlatTreeList (list, result = []) {
            for (const item of list) {
                result.push({
                    name: item.name,
                    catalogId: item.catalogId,
                    catalogLevel: item.catalogLevel,
                    pCatalogId: item.pCatalogId || '',
                    type: item.type,
                    catalogLink: item.catalogLink,
                });
                if (item.children && item.children.length) {
                    this.getFlatTreeList(item.children, result);
                }
            }
            return result;
        },
    },
};
</script>

<style scoped lang="scss">
.web-003 {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    overflow-x: auto;
    background-color: #FFFFFF;
    box-sizing: border-box;
    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background: #d8d8d8;
        border-radius: 10px;
    }
    &::-webkit-scrollbar-track-piece {
        background: transparent;
    }
    scrollbar-width: thin;
    .web-content {
        overflow: hidden;
        //overflow-y: auto;
        width: 100vw;
        margin-top: 80px;
        height: calc(100vh - 80px);
        &::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background: #d8d8d8;
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track-piece {
            background: transparent;
        }
        scrollbar-width: thin;

        ::v-deep .el-scrollbar__wrap{
            overflow-x: hidden;
            height: 100%;
            scroll-behavior: smooth;
            >div {
                overflow-x: hidden;
            }
        }
    }
    .backTopDiv{
        cursor: pointer;
        position: fixed;
        bottom: 60px;
        right: 60px;
        width: 40px;
        height: 40px;
        z-index: 2000;
        text-align: center;
        line-height: 40px;
        font-size: 18px;
        color: #2ed095;
        border-radius: 50%;
        box-shadow: 0 0 4px 1px rgba(200, 200, 200, .6);
        background: #fff;
    }
}
</style>
